import * as R from 'ramda'
import uuidv4 from '@/utilities/uuid.js'
import api from '@/api'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'

const otherExpenseItemPresenter = (otherExpenseItem, itemId) => {
  return {
    id: itemId,
    description: otherExpenseItem['description'],
    cost: otherExpenseItem['cost'],
    defaultQuantity: otherExpenseItem['defaultQuantity']
  }
}

const state = {
  otherExpenseItems: {}
}

const mutations = {
  LOAD_OTHER_EXPENSE_ITEMS (state, payload) {
    state.otherExpenseItems = payload
  },

  UPDATE_OTHER_EXPENSE_ITEM (state, { id, item }) {
    state.otherExpenseItems[id] = item
  },

  ADD_OTHER_EXPENSE_ITEM (state, { id, item }) {
    const items = {
      ...state.otherExpenseItems,
      [id]: item
    }

    state.otherExpenseItems = items
  },

  DELETE_OTHER_EXPENSE_ITEM (state, payload) {
    state.otherExpenseItems = R.omit(payload, state.otherExpenseItems)
  }
}

const actions = {
  updateOtherExpenseItem ({ commit, getters }, jsConn) {
    if (jsConn.formParams.id === 'new') {
      const id = uuidv4()
      jsConn.formParams = {
        id: id,
        item: jsConn.formParams.item
      }

      if (getters.signedIn) {
        return api.createOtherExpense(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
            commit('ADD_OTHER_EXPENSE_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.formParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved for this browser session'
        commit('ADD_OTHER_EXPENSE_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    } else {
      if (getters.signedIn) {
        return api.updateOtherExpense(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            commit('UPDATE_OTHER_EXPENSE_ITEM', jsConn.formParams)
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            return Promise.reject(jsConn)
          })
      } else {
        commit('UPDATE_OTHER_EXPENSE_ITEM', jsConn.formParams)
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated for this browser session'
        return Promise.resolve(jsConn)
      }
    }
  },

  deleteOtherExpenseItem ({ commit, getters, dispatch }, jsConn) {
    if (getters.signedIn) {
      return api.deleteOtherExpense(jsConn)
        .then((jsConn) => {
          return successPipeline(jsConn)
        })
        .then(jsConn => {
          dispatch('deleteOtherExpenseItemFromAllCrops', jsConn)
          commit('DELETE_OTHER_EXPENSE_ITEM', [jsConn.formParams['id']])
          jsConn.toastMessage = 'Other expense item deleted'
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          jsConn.toastMessage = 'Unable to delete item'
          return Promise.reject(jsConn)
        })
    } else {
      dispatch('deleteOtherExpenseItemFromAllCrops', jsConn)
      commit('DELETE_OTHER_EXPENSE_ITEM', [jsConn.formParams['id']])
      jsConn.toastMessage = 'Other expense item deleted for this browser session'
      return Promise.resolve(jsConn)
    }
  }
}

const getters = {
  otherExpenseItems: state => state.otherExpenseItems,

  otherExpenseItemsIdList: state => {
    return Object.keys(state.otherExpenseItems)
  },

  otherExpenseItemsList: (state, getters) => {
    const itemsList = R.map((itemId) => {
      const item = getters.getOtherExpenseItemById(itemId)
      return otherExpenseItemPresenter(item, itemId)
    }, getters.otherExpenseItemsIdList)

    return itemsList
  },

  getOtherExpenseItemById: (state) => (id) => {
    return state.otherExpenseItems[id]
  }
}

const otherExpenseModule = {
  state,
  mutations,
  actions,
  getters
}

export default otherExpenseModule
